class ContainerSideContainer
    extends QueryElement<HTMLElement>
    implements ISiteContainer 
{
    private readonly _site: Site;

    get Config() { return { }; }
    get SiteConfig() { return this._site.Config; }
    
    constructor(site: Site) {
        super(document.createElement("div"))

        this.addClass("container");
        this.addClass("mobile");
        this.addClass("mobile-small");
        this.addClass("no-labels");

        this._site = site;
    }
    redraw() {
        // Do nothing
    }

    async post(request: ISiteRequest): Promise<boolean> {
        return await this._site.post(request);
    }
    request(card: ISiteCard, request: ISiteRequest): Promise<boolean> {
        let command = new SiteContainerRequestCommand(
            this._site,
            this,
            card,
            request);
        return command.execute();
    }
    async back(): Promise<void> {
        let activeCard = this.lastChild<SiteCard>();
        
        if (activeCard) {
            await this.removeCard(activeCard);
        }
    }
    async appendCard(card: SiteCard): Promise<void> {
        this.append(card);
        await card.start();
    }
    async makeCardActive(card: ISiteCard): Promise<void> {
        let activeCard = this.getActiveCard();

        if (card === activeCard)
            return;

        if (activeCard !== null)
            activeCard.makeInactive();
        
        this.trigger("qts.card", false, card);
        card.makeActive();
    }
    async replaceCard(oldCard: ISiteCard, newCard: ISiteCard): Promise<void> {

    }
    async removeNextCards(card: ISiteCard): Promise<void> {
        let cards: SiteCard[] = [];
        card.nextAll<SiteCard>(a => { cards.push(a); });

        for (let toRemove of cards.reverse()) {
            await this.removeCard(toRemove);
        };
    }
    async removeCard(card: ISiteCard): Promise<void> {
        let toActivate = card.next<SiteCard>() || card.prev<SiteCard>();
        await card.remove();

        if (toActivate !== null)
            await this.makeCardActive(toActivate);
    }
    getCards() {
        return this.query(".card");
    }
    getActiveCard() {
        return this.query(".card.active")
            .first<SiteCard>();
    }

    open() {
        let card = new SiteCardContainerWrapper(this);
        this.request(card, {
            request: {
                module: "AI",
                controller: "AI",
                action: "Index"
            }
        });
    }
    close() {
        this.query(".card")
            .all<SiteCard, any>(a => a.remove(true));
    }
}

class SiteContainerSide
    extends QueryElement<HTMLElement>{
    
    private readonly _container: ContainerSideContainer;
    

    constructor(element: HTMLElement, site: Site) {
        super(element, false);
        
        this._container = new ContainerSideContainer(site).appendTo(this);
    }
    open() {
        this.addClass("active");
        this._container.open();
    }
    close() {
        this.removeClass("active");
        this._container.close();
    }
}